import { forwardRef } from "react";

const GDRLogo = forwardRef<SVGSVGElement, { className?: string; }>(function GDRLogo({
    className,
  }, ref) {
    return (
        <svg ref={ref} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 557.2 321.39" fill="currentColor" aria-hidden="true" data-slot="icon" className={className}>
            <polygon points="524.43 321.39 557.2 321.39 422.24 86.18 342.04 86.18 292.66 0 183.44 0 0 321.39 108.93 321.39 276.35 28.73 311.22 89.47 178.35 321.39 288.1 321.39 406.15 114.69 524.43 321.39"/>
            <rect x="359.99" y="228.92" width="40.4" height="40.4" rx="9.19" ry="9.19"/>
            <rect x="412.36" y="228.92" width="40.4" height="40.4" rx="9.19" ry="9.19"/>
            <rect x="359.99" y="280.99" width="40.4" height="40.4" rx="9.19" ry="9.19"/>
            <rect x="412.36" y="280.99" width="40.4" height="40.4" rx="9.19" ry="9.19"/>
        </svg>
    )
});

GDRLogo.displayName = 'GDRLogo'

export { GDRLogo };
